/* rz-lp.js - comportamento da landing de oferta unica (Rientro Zero)
   Sem dependencias externas. Custom elements + IntersectionObserver nativos. */
(function () {
  'use strict';

  if (window.__rzLpInitialized) return;
  window.__rzLpInitialized = true;

  var money = function (cents, fmt) {
    var format = fmt || '€{{amount_with_comma_separator}}';

    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents, format);
    }

    var amount = (Number(cents || 0) / 100).toFixed(2);
    var commaAmount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace(/\.(\d{2})$/, ',$1');

    return format.replace(/\{\{\s*(amount(?:_with_comma_separator)?)\s*\}\}/, function (_token, type) {
      return type === 'amount_with_comma_separator' ? commaAmount : amount;
    });
  };

  var normalizeName = function (value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  };

  if (!customElements.get('rz-bundle-picker')) {
    customElements.define(
      'rz-bundle-picker',
      class extends HTMLElement {
        connectedCallback() {
          this.options = Array.from(this.querySelectorAll('[data-rz-bundle]'));
          this.submit = this.querySelector('[data-rz-bundle-submit]');
          this.priceEl = this.querySelector('[data-rz-bundle-total]');
          this.compareEl = this.querySelector('[data-rz-bundle-compare]');
          this.statusEl = this.querySelector('[data-rz-bundle-status]');
          this.fmt = this.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
          this.syncingCanonical = false;

          this.options.forEach((el) => {
            el.addEventListener('click', () => this.select(el, false, true));
            el.addEventListener('keydown', (e) => {
              if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); this.select(el, false, true); }
              if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); this.move(1); }
              if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); this.move(-1); }
            });
          });

          var pre = this.options.find((o) => o.getAttribute('aria-checked') === 'true') || this.options[0];
          if (pre) this.select(pre, true, false);

          if (this.submit) this.submit.addEventListener('click', (e) => this.addToCart(e));

          this.onCanonicalChange = (e) => {
            if (e.target && e.target.closest && e.target.closest('.kaching-bundles')) {
              window.setTimeout(() => this.syncFromCanonical(), 0);
            }
          };
          document.addEventListener('change', this.onCanonicalChange, true);
          document.addEventListener('click', this.onCanonicalChange, true);

          this.bindCanonicalObserver();
          [0, 250, 750, 1500].forEach((delay) => {
            window.setTimeout(() => this.syncFromCanonical(), delay);
          });
        }

        disconnectedCallback() {
          document.removeEventListener('change', this.onCanonicalChange, true);
          document.removeEventListener('click', this.onCanonicalChange, true);
          if (this.canonicalObserver) this.canonicalObserver.disconnect();
          if (this.pageObserver) this.pageObserver.disconnect();
        }

        move(dir) {
          var i = this.options.findIndex((o) => o.getAttribute('aria-checked') === 'true');
          var next = this.options[(i + dir + this.options.length) % this.options.length];
          if (next) { this.select(next, false, true); next.focus(); }
        }

        select(el, silent, syncCanonical) {
          this.options.forEach((o) => {
            o.setAttribute('aria-checked', String(o === el));
            o.tabIndex = o === el ? 0 : -1;
          });
          var id = el.dataset.variantId;
          var price = parseInt(el.dataset.price || '0', 10);
          var compare = parseInt(el.dataset.compare || '0', 10);
          var available = el.dataset.available === 'true';

          if (this.priceEl) this.priceEl.textContent = money(price, this.fmt);
          if (this.compareEl) {
            this.compareEl.textContent = compare > price ? money(compare, this.fmt) : '';
            this.compareEl.hidden = !(compare > price);
          }
          if (this.submit) {
            this.submit.disabled = !available;
            var label = available ? this.submit.dataset.labelAdd : this.submit.dataset.labelSoldout;
            var span = this.submit.querySelector('[data-rz-label]');
            if (span && label) span.textContent = label;
          }

          document.dispatchEvent(
            new CustomEvent('rz-lp:variant', { detail: { id: id, price: price, compare: compare, available: available, name: el.dataset.name || '' } })
          );

          if (!silent) this.dataset.touched = 'true';
          if (syncCanonical) this.syncCanonical(el);
        }

        getCanonicalForm() {
          return document.querySelector('form[data-product-form]');
        }

        getCanonicalVariantId() {
          var form = this.getCanonicalForm();
          var input = form && form.querySelector('input[name="id"]');
          return input ? String(input.value) : '';
        }

        getSelectedOption() {
          return this.options.find((o) => o.getAttribute('aria-checked') === 'true');
        }

        getKachingBar(el) {
          var bars = Array.from(document.querySelectorAll('.kaching-bundles__bar'));
          var targetName = normalizeName(el && el.dataset.name);
          var match = bars.find((bar) => {
            var title = bar.querySelector('.kaching-bundles__bar-title');
            return title && normalizeName(title.textContent) === targetName;
          });

          if (!match && bars.length === this.options.length) {
            match = bars[this.options.indexOf(el)];
          }

          return match || null;
        }

        syncCanonical(el) {
          if (!el || this.syncingCanonical) return;
          if (this.getCanonicalVariantId() === String(el.dataset.variantId)) return;

          var bar = this.getKachingBar(el);
          var target = bar && (bar.querySelector('.kaching-bundles__bar-main') || bar.querySelector('label') || bar.querySelector('input'));
          if (!target || typeof target.click !== 'function') return;

          this.syncingCanonical = true;
          target.click();
          window.setTimeout(() => {
            this.syncingCanonical = false;
            this.syncFromCanonical();
          }, 0);
        }

        syncFromCanonical() {
          var id = this.getCanonicalVariantId();
          var option = this.options.find((o) => String(o.dataset.variantId) === id);

          if (!option) {
            var selectedTitle = document.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-title');
            var name = normalizeName(selectedTitle && selectedTitle.textContent);
            option = this.options.find((o) => normalizeName(o.dataset.name) === name);
          }

          if (option && option !== this.getSelectedOption()) this.select(option, true, false);
        }

        bindCanonicalObserver() {
          var root = document.querySelector('.kaching-bundles');
          if (root) {
            this.canonicalObserver = new MutationObserver(() => this.syncFromCanonical());
            this.canonicalObserver.observe(root, { attributes: true, childList: true, subtree: true, attributeFilter: ['class'] });
            return;
          }

          this.pageObserver = new MutationObserver(() => {
            if (!document.querySelector('.kaching-bundles')) return;
            this.pageObserver.disconnect();
            this.bindCanonicalObserver();
            this.syncFromCanonical();
          });
          this.pageObserver.observe(document.body, { childList: true, subtree: true });
        }

        waitForCanonical(id, attempts) {
          return new Promise((resolve, reject) => {
            var check = () => {
              var form = this.getCanonicalForm();
              var property = form && form.querySelector('input[name="properties[__kaching_bundles]"]');
              if (form && this.getCanonicalVariantId() === String(id) && property && property.value) {
                resolve(form);
                return;
              }
              if (attempts <= 0) {
                reject(new Error('Canonical product form did not reach the selected tier.'));
                return;
              }
              attempts -= 1;
              window.setTimeout(check, 50);
            };
            check();
          });
        }

        addToCart(e) {
          e.preventDefault();
          var selected = this.getSelectedOption();
          if (!selected || selected.dataset.available !== 'true') return;

          var btn = this.submit;
          if (btn) btn.classList.add('is-loading');
          if (this.statusEl) this.statusEl.hidden = true;

          this.syncCanonical(selected);
          this.waitForCanonical(selected.dataset.variantId, 40)
            .then((form) => {
              var canonicalSubmit = form.querySelector('[data-add-to-cart]');
              if (!canonicalSubmit || canonicalSubmit.disabled || typeof canonicalSubmit.click !== 'function') {
                throw new Error('Canonical add-to-cart button is unavailable.');
              }
              canonicalSubmit.click();
              document.dispatchEvent(new CustomEvent('rz-lp:added'));
            })
            .catch((error) => {
              console.error('[Rientro Zero] Final CTA delegation failed:', error);
              if (this.statusEl) {
                this.statusEl.textContent = 'Seleziona di nuovo il set e riprova.';
                this.statusEl.hidden = false;
              }
            })
            .finally(() => {
              window.setTimeout(() => { if (btn) btn.classList.remove('is-loading'); }, 900);
            });
        }
      }
    );
  }

  var sticky = document.querySelector('[data-rz-sticky]');
  if (sticky && sticky.classList.contains('is-on')) {
    var anchor = document.querySelector('[data-rz-sticky-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting); });
        },
        { rootMargin: '0px 0px -60% 0px' }
      ).observe(anchor);
    }
    document.addEventListener('rz-lp:variant', function (e) {
      var n = sticky.querySelector('[data-rz-sticky-name]');
      var p = sticky.querySelector('[data-rz-sticky-price]');
      if (n && e.detail.name) n.textContent = e.detail.name;
      if (p) p.textContent = money(e.detail.price, sticky.dataset.moneyFormat || '€{{amount}}');
    });
  }

  var reveals = document.querySelectorAll('.rz-lp-reveal');
  if (reveals.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  var nav = document.querySelector('[data-rz-nav]');
  if (nav) {
    var links = Array.from(nav.querySelectorAll('a[href^="#"]'));
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('href'));
        if (!t) return;
        e.preventDefault();
        var off = nav.getBoundingClientRect().height + 8;
        window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - off, behavior: 'smooth' });
      });
    });
    if ('IntersectionObserver' in window) {
      links.forEach(function (l) {
        var t = document.querySelector(l.getAttribute('href'));
        if (!t) return;
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              if (!en.isIntersecting) return;
              links.forEach(function (x) { x.classList.toggle('is-active', x === l); });
            });
          },
          { rootMargin: '-20% 0px -70% 0px' }
        ).observe(t);
      });
    }
  }
})();
